// src/pages/pedidos/AddItemPedidoModal.js
// pages/pedidos/AddItemPedidoModal.js
import React, { useEffect, useMemo, useState } from "react";
import ModalContainer from "../../components/modalForm/ModalContainer";
import ModalHeader from "../../components/modalForm/ModalHeader";
import ModalBody from "../../components/modalForm/ModalBody";
import ModalFooter from "../../components/modalForm/ModalFooter";
import ModalActions, { ModalActionButton } from "../../components/modalForm/ModalActions";
import ModalQuantityControl from "../../components/modalForm/ModalQuantityControl";
import Input from "../../components/input/Input";
import { FiCheckCircle, FiChevronRight, FiLayers, FiPlusSquare } from "react-icons/fi";
import "./AddItemPedidoModal.css";

import { usePedido } from "../../contexts/pedidos/PedidoContext";
import { usePedidoItem } from "../../contexts/pedidos/PedidoItemContext";

import { useProdutoConjunto } from "../../contexts/produtos/combos/ProdutoConjuntoContext";
import { useAdicional } from "../../contexts/produtos/AdicionalContext";
import { useMessage } from "../../contexts/geral/MessageContext";

import ConjuntoSelecaoModal from "../../components/modal/produtos/ConjuntoSelecaoModal";
import { formatCurrency } from "../../utils/numberUtils";
import { calcularPreviaPedidoItem, obterIdsConjuntosGeradores } from "../../models/pedidos/PedidoItemCalculo";
import SelecaoVariacoes from '../../components/modal/produtos/SelecaoVariacoes';
import { criarEscolhasVariacao, obterErrosVariacoes } from '../../utils/VariacaoUtils';
//import { FaUtensils } from "react-icons/fa";

export default function AddItemPedidoModal({
  show,
  onClose,
  produtoInicial,
  pedidoItemEditar,
  onSaved,
  headerColors,
  mostrarEnviarParaCozinha = false,
  defaultEnviarParaCozinha = true,
  aplicarRegrasConjunto = false
}) {
  const { pedidoSel } = usePedido();
  const { addPedidoItem, updatePedidoItem } = usePedidoItem();
  const { showMessage } = useMessage();

  const emEdicao = !!(pedidoItemEditar && pedidoItemEditar.id && pedidoItemEditar.id !== 0);

  const {
    fetchProdutoConjuntosDetalhado,
    produtoConjuntosDetalhado,
    setProdutoConjuntosDetalhado
  } = useProdutoConjunto();

  const { adicionaisProduto, fetchAdicionaisProdutos } = useAdicional();

  const [produtoSel, setProdutoSel] = useState(null);
  const [qtd, setQtd] = useState(1);
  const [obs, setObs] = useState("");
  const [enviarParaCozinha, setEnviarParaCozinha] = useState(defaultEnviarParaCozinha);
  const [erroVariacao, setErroVariacao] = useState({});

  // ✅ aqui é o “coração”: igual CadPedidoItem, porém local
  const [pedidoItemSelLocal, setPedidoItemSelLocal] = useState(null);

  // UI
  const [valorAdic, setValorAdic] = useState(0); // total
  const [valorUnitario, setValorUnitario] = useState(0);
  const [total, setTotal] = useState(0);

  const [modalConjSel, setModalConjSel] = useState(false);
  const [conjuntoSel, setConjuntoSel] = useState(null);

  const conjuntosDetalhados = useMemo(() => {
    if (!produtoConjuntosDetalhado?.length) return [];
    return produtoConjuntosDetalhado.map(pc => pc.conjunto).filter(Boolean);
  }, [produtoConjuntosDetalhado]);

  const quantidadeAutomatica = useMemo(() => {
    return aplicarRegrasConjunto && obterIdsConjuntosGeradores(conjuntosDetalhados).size > 0;
  }, [aplicarRegrasConjunto, conjuntosDetalhados]);

  useEffect(() => {
    if (!show) return;
    setEnviarParaCozinha(defaultEnviarParaCozinha);

    // ✅ EDIÇÃO
    if (pedidoItemEditar) {
      const p = pedidoItemEditar.produto;


      setProdutoSel(p);
      setQtd(pedidoItemEditar.qtde ?? 1);
      setObs(pedidoItemEditar.observacao || "");
      setErroVariacao({});

      fetchAdicionaisProdutos(p.id);
      fetchProdutoConjuntosDetalhado(p.id);

      setPedidoItemSelLocal({
        ...pedidoItemEditar,
        produtoId: p.id,
        produto: p,
        variacao: null,
        pedidoItemVariacoes: criarEscolhasVariacao(p, pedidoItemEditar.pedidoItemVariacoes, pedidoItemEditar.variacao, false),
        pedidoItemAdicionais: pedidoItemEditar.pedidoItemAdicionais || [],
        pedidoItemConjuntos: pedidoItemEditar.pedidoItemConjuntos || [],
      });

      // recalcula UI
      const base = Number(p.preco || 0);
      recalcularTotais(base, pedidoItemEditar.qtde ?? 1, {
        ...pedidoItemEditar,
        pedidoItemVariacoes: criarEscolhasVariacao(p, pedidoItemEditar.pedidoItemVariacoes, pedidoItemEditar.variacao, false),
        pedidoItemAdicionais: pedidoItemEditar.pedidoItemAdicionais || [],
        pedidoItemConjuntos: pedidoItemEditar.pedidoItemConjuntos || [],
      });

      return;
    }

    // ✅ INCLUSÃO (como já estava)
    if (produtoInicial) {
      selecionarProduto(produtoInicial);
    } else {
      setProdutoSel(null);
      setQtd(1);
      setObs("");
      setPedidoItemSelLocal(null);
      setErroVariacao({});
      setValorAdic(0);
      setValorUnitario(0);
      setTotal(0);
      fetchAdicionaisProdutos(null);
      setProdutoConjuntosDetalhado?.([]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, produtoInicial, pedidoItemEditar]);



  useEffect(() => {
    if (!produtoSel || !pedidoItemSelLocal) return;
    const base = Number(produtoSel.preco || 0);
    recalcularTotais(base, pedidoItemSelLocal.qtde ?? 1, pedidoItemSelLocal);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    // produtoSel?.id,
    // pedidoItemSelLocal?.qtde,
    pedidoItemSelLocal?.pedidoItemVariacoes,
    pedidoItemSelLocal?.pedidoItemAdicionais,
    pedidoItemSelLocal?.pedidoItemConjuntos,
    conjuntosDetalhados,
    quantidadeAutomatica
  ]);

  const selecionarProduto = (p) => {


    setProdutoSel(p);
    setQtd(1);
    setObs("");
    setErroVariacao({});

    fetchAdicionaisProdutos(p.id);
    fetchProdutoConjuntosDetalhado(p.id);

    // ✅ inicia o “pedidoItemSel” local
    const novo = {
      id: 0,
      pedidoId: pedidoSel?.id || 0,
      produtoId: p.id,
      produto: p,
      variacao: null,
      pedidoItemVariacoes: criarEscolhasVariacao(p),
      qtde: 1,
      observacao: "",
      valorItem: Number(p.preco || 0),
      valorAdicional: 0, // UNITÁRIO
      valorTotal: Number(p.preco || 0),
      pedidoItemAdicionais: [],
      pedidoItemConjuntos: []
    };

    setPedidoItemSelLocal(novo);

    // total UI
    setValorAdic(0);
    setValorUnitario(Number(p.preco || 0));
    setTotal(Number(p.preco || 0));
  };

  // ✅ Recalcula para a modal: no fluxo manual, conjuntos são cobrados por seleção (linha).
  // No modo automático, adicionais normais acompanham a quantidade gerada pelos conjuntos.
  const recalcularTotais = (basePreco, qtde, pedidoItem) => {
    const previa = calcularPreviaPedidoItem({
      produto: produtoSel,
      pedidoItem,
      conjuntos: conjuntosDetalhados,
      quantidadeManual: qtde,
      aplicarRegrasConjunto
    });

    setQtd(previa.quantidade);
    setValorAdic(previa.valorAdicional);
    setValorUnitario(previa.valorUnitario);
    setTotal(previa.valorTotal);

    return {
      adicionalTotal: previa.valorAdicional,
      valorItemTotal: previa.valorItem,
      valorUnitario: previa.valorUnitario,
      valorTotal: previa.valorTotal,
      quantidade: previa.quantidade
    };
  };

  const alterarQtd = (n) => {
    if (quantidadeAutomatica) return;

    const novo = Math.max(1, n);
    setQtd(novo);

    setPedidoItemSelLocal(prev => {
      if (!prev || !produtoSel) return prev;

      const base = Number(produtoSel.preco || 0);
      const { adicionalTotal, valorItemTotal, valorTotal, quantidade } = recalcularTotais(base, novo, prev);

      return {
        ...prev,
        qtde: quantidade,
        valorItem: valorItemTotal,      // total do item (base * qtde)
        valorAdicional: adicionalTotal, // TOTAL da linha (não multiplica por qtd)
        valorTotal,
      };
    });
  };

  const handleToggleAdicional = (adicional) => {
    setPedidoItemSelLocal(prev => {
      if (!prev || !produtoSel) return prev;

      const ja = prev.pedidoItemAdicionais?.some(a => a.adicionalId === adicional.id);
      const novos = ja
        ? prev.pedidoItemAdicionais.filter(a => a.adicionalId !== adicional.id)
        : [...(prev.pedidoItemAdicionais || []), { adicionalId: adicional.id, valor: adicional.preco, adicional }];

      const base = Number(produtoSel.preco || 0);
      const novoItem = { ...prev, pedidoItemAdicionais: novos };

      const { adicionalTotal, valorItemTotal, valorTotal, quantidade } = recalcularTotais(base, prev.qtde ?? 1, novoItem);

      return {
        ...novoItem,
        qtde: quantidade,
        valorItem: valorItemTotal,
        valorAdicional: adicionalTotal, // TOTAL da linha (não multiplica por qtd)
        valorTotal,
      };
    });
  };

  const validateForm = () => {
    if (!produtoSel?.id) return false;
    if (quantidadeAutomatica && Number(qtd || 0) <= 0) {
      showMessage("Selecione ao menos um item de um conjunto que gera quantidade.", "warning");
      return false;
    }
    if (Number(total || 0) <= 0) {
      showMessage(`O item "${produtoSel?.descricao || "sem nome"}" está com valor zerado!`, "warning");
      return false;
    }
    const errosVariacoes = obterErrosVariacoes(produtoSel, pedidoItemSelLocal?.pedidoItemVariacoes);
    if (Object.keys(errosVariacoes).length) { setErroVariacao(errosVariacoes); return false; }
    setErroVariacao({});
    return true;
  };

  const onSubmit = async (pedidoItemPayload) => {
    if (!validateForm()) return;

    try {
      // ✅ pedido já existe → deixa o contexto cuidar da lista
      if (pedidoSel?.id && pedidoSel.id !== 0) {
        if (!pedidoItemPayload?.id || pedidoItemPayload.id === 0) {
          await addPedidoItem(pedidoItemPayload);
        } else {
          await updatePedidoItem(pedidoItemPayload);
        }

        onClose();
        return; // ✅ NÃO chama onSaved aqui
      }

      // ✅ pedido novo → memória (precisa onSaved)
      onSaved?.(pedidoItemPayload, { enviarParaCozinha });
      onClose();
    } catch (error) {
      console.error("Erro ao gravar item do pedido:", error);
    }
  };



  const handleConfirmar = async () => {
    if (!produtoSel) return;

    const previa = calcularPreviaPedidoItem({
      produto: produtoSel,
      pedidoItem: pedidoItemSelLocal,
      conjuntos: conjuntosDetalhados,
      quantidadeManual: qtd,
      aplicarRegrasConjunto
    });

    const payload = {
      ...(pedidoItemSelLocal || {}),
      pedidoId: pedidoSel?.id || 0,
      produtoId: produtoSel.id,
      produto: produtoSel,

      qtde: previa.quantidade,
      observacao: obs,
      variacao: null,
      pedidoItemVariacoes: pedidoItemSelLocal?.pedidoItemVariacoes || [],

      // ✅ valores coerentes SEMPRE
      valorItem: previa.valorItem,
      valorAdicional: previa.valorAdicional,
      valorTotal: previa.valorTotal,

      // ✅ garante tempId em pedido novo
      tempId: (pedidoItemSelLocal?.tempId || (!pedidoItemSelLocal?.id ? Date.now() : pedidoItemSelLocal?.tempId)),

      pedidoItemAdicionais: (pedidoItemSelLocal?.pedidoItemAdicionais || []),
      pedidoItemConjuntos: (pedidoItemSelLocal?.pedidoItemConjuntos || []),
    };

    await onSubmit(payload);
  };


  if (!show) return null;

  return (
    <ModalContainer
      show={show} variant="cadastro" onHide={onClose}
      largura="900px" contentClassName="additem-pedido-modal modal-operacional"
    >
      <ModalHeader title={emEdicao ? "Alterar Item" : "Adicionar Item"} icon={FiPlusSquare} onHide={onClose} headerColors={headerColors} />

      <ModalBody>
        <div className="additem-grid">
          {/* ESQUERDA */}
          <div className="additem-montagem">
            <div className="additem-produto">
              <p className="additem-pedido">
                <span>Pedido</span> <strong>{pedidoSel?.id ? `Nº ${pedidoSel.id}` : "Novo"}</strong>
              </p>

              <p className="additem-grupo">
                Grupo: {produtoSel?.grupo?.descricao || "—"}
              </p>

              <h3 className="additem-produto-title">{produtoSel?.descricao}</h3>
            </div>

            {/* CONJUNTOS */}
            <div className="additem-conjuntos">
              {conjuntosDetalhados.map(c => {
                const quantidadeSelecionada = (pedidoItemSelLocal?.pedidoItemConjuntos || [])
                  .filter(item => Number(item.conjuntoId) === Number(c.id))
                  .reduce((quantidade, item) => quantidade + Number(item.qtdItens || 0), 0);
                const selecionado = quantidadeSelecionada > 0;

                return (
                  <button
                    key={c.id}
                    onClick={() => { setConjuntoSel(c); setModalConjSel(true); }}
                    type="button" className={`additem-conjunto${selecionado ? " selecionado" : ""}`}
                    aria-haspopup="dialog"
                  >
                    <span className="additem-conjunto-icone" aria-hidden="true">
                      {selecionado ? <FiCheckCircle /> : <FiLayers />}
                    </span>
                    <span className="additem-conjunto-conteudo">
                      <span className="additem-conjunto-titulo">
                        <span className="additem-conjunto-nome">{c.nome}</span>
                        {c.qtdMax ? <small className="additem-conjunto-limite">Máx. {c.qtdMax}</small> : null}
                      </span>
                      <span className="additem-conjunto-status">
                        {selecionado
                          ? `${quantidadeSelecionada} ${quantidadeSelecionada === 1 ? "item selecionado" : "itens selecionados"}`
                          : "Escolher opções"}
                      </span>
                    </span>
                    <FiChevronRight className="additem-conjunto-seta" aria-hidden="true" />
                  </button>
                );
              })}
            </div>

            {/* VARIACOES */}
            <div className="additem-variacoes">
              <SelecaoVariacoes produto={produtoSel} escolhas={pedidoItemSelLocal?.pedidoItemVariacoes || []} erros={erroVariacao}
                onChange={pedidoItemVariacoes => { setErroVariacao({}); setPedidoItemSelLocal(prev => ({ ...prev, pedidoItemVariacoes })); }} />
            </div>

            {/* ADICIONAIS */}
            {adicionaisProduto?.length > 0 && (
              <div className="additem-adicionais">
                <strong>Adicionais</strong>
                <div className="additem-adicionais-opcoes">
                  {adicionaisProduto.map(ad => {
                    const selecionado = pedidoItemSelLocal?.pedidoItemAdicionais?.some(a => a.adicionalId === ad.id);
                    return (
                      <button
                        key={ad.id}
                        type="button"
                        aria-pressed={!!selecionado}
                        onClick={() => handleToggleAdicional(ad)}
                        className={`btn ${selecionado ? "btn-primary" : "btn-outline-primary"} btn-sm`}
                      >
                        {ad.descricao} ({formatCurrency(ad.preco)})
                      </button>
                    );
                  })}
                </div>
              </div>
            )}

            {/* LISTA SELECIONADOS (conjuntos + adicionais) */}
            {(conjuntosDetalhados.length > 0 || adicionaisProduto?.length > 0) && (
              <div className="additem-selecionados">
                <strong>Itens adicionados</strong>

                <div className="additem-selecionados-lista">
                  {(!pedidoItemSelLocal?.pedidoItemConjuntos?.length && !pedidoItemSelLocal?.pedidoItemAdicionais?.length) && (
                    <p className="additem-sem-adicionais">Nenhum adicional selecionado</p>
                  )}

                  {(pedidoItemSelLocal?.pedidoItemConjuntos || []).map((i, idx) => {
                    const conjuntoDoItem = conjuntosDetalhados.find(
                      conjunto => Number(conjunto.id) === Number(i.conjuntoId)
                    );
                    const defineValor = aplicarRegrasConjunto && conjuntoDoItem?.defineValorItem === true;
                    const nome =
                      i?.conjuntoItemNome ||
                      i?.descricao ||
                      i?.produto?.descricao ||
                      i?.conjuntoItem?.nome ||
                      `Item ${i?.conjuntoItemId || ""}`;

                    return (
                      <div key={`cj-${idx}`} className="additem-selecionado">
                        <span>• {nome} ({i.qtdItens})</span>
                        <span>
                          {defineValor ? "Valor: " : ""}
                          {formatCurrency(defineValor
                            ? (i.valorAdicional || 0)
                            : (i.valorAdicional || 0) * (i.qtdItens || 0))}
                        </span>
                      </div>
                    );
                  })}


                  {(pedidoItemSelLocal?.pedidoItemAdicionais || []).map((a, idx) => (
                    <div key={`ad-${idx}`} className="additem-selecionado">
                      <span>• {a.adicional?.descricao}</span>
                      <span>{formatCurrency(a.valor || 0)}</span>
                    </div>
                  ))}
                </div>

                <div className="additem-total-adicionais">
                  <span>Total adicional</span>
                  <span>{formatCurrency(valorAdic)}</span>
                </div>
              </div>
            )}
          </div>

          {/* DIREITA */}
          <div className="additem-resumo">
            <div className="additem-valores">
              <div className="additem-valor-linha">
                <span>Valor Unitário:</span>
                <strong>{formatCurrency(valorUnitario)}</strong>
              </div>

              {valorAdic > 0 && (
                <div className="additem-valor-linha">
                  <span>Adicionais:</span>
                  <strong>{formatCurrency(valorAdic)}</strong>
                </div>
              )}

              <div className="additem-total">
                <span>Total do item</span>
                <strong>{formatCurrency(total)}</strong>
              </div>

              <div className="additem-quantidade">
                <span>Quantidade</span>
                <div><ModalQuantityControl name={produtoSel?.descricao || "item"} value={qtd}
                  decreaseDisabled={quantidadeAutomatica} increaseDisabled={quantidadeAutomatica}
                  onDecrease={() => alterarQtd(qtd - 1)} onIncrease={() => alterarQtd(qtd + 1)} /></div>
              </div>
            </div>

            <Input label="Observação" size="100%"
              placeholder="Observação..."
              rows={4}
              value={obs}
              onChange={(e) => {
                setObs(e.target.value);
                setPedidoItemSelLocal(prev => prev ? ({ ...prev, observacao: e.target.value }) : prev);
              }}
            />

            {/* {mostrarEnviarParaCozinha && (
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  marginBottom: 15,
                  padding: "10px 12px",
                  border: "1px solid #ccc",
                  borderRadius: 10,
                  cursor: "pointer"
                }}
              >
                <input
                  type="checkbox"
                  checked={enviarParaCozinha}
                  onChange={(e) => setEnviarParaCozinha(e.target.checked)}
                />
                <FaUtensils color="#D97706" />
                <span style={{ fontWeight: 600 }}>Enviar para cozinha</span>
              </label>
            )} */}


          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="additem-footer-total"><span>Total do item</span><strong>{formatCurrency(total)}</strong></div>
        <ModalActions className="additem-footer-actions">
          <ModalActionButton action="close" onClick={onClose}>Cancelar</ModalActionButton>
          <ModalActionButton action={emEdicao ? "save" : "add"} onClick={handleConfirmar}
            disabled={!produtoSel || (quantidadeAutomatica && qtd <= 0)}>{emEdicao ? "Salvar" : "Adicionar"}</ModalActionButton>
        </ModalActions>
      </ModalFooter>

      {/* ✅ AQUI está a correção que faz o conjunto “ir pro pedido” */}
      <ConjuntoSelecaoModal
        show={modalConjSel}
        headerColors={headerColors}
        onClose={() => setModalConjSel(false)}
        conjunto={conjuntoSel}
        produto={produtoSel || produtoInicial}
        aplicarRegrasConjunto={aplicarRegrasConjunto}
        pedidoItemSel={pedidoItemSelLocal}
        setPedidoItemSel={(novo) => {
          // recalcula imediatamente após o conjunto atualizar
          if (novo && produtoSel) {
            const base = Number(produtoSel.preco || 0);
            const previa = recalcularTotais(base, novo.qtde ?? 1, novo);
            setPedidoItemSelLocal({
              ...novo,
              qtde: previa.quantidade,
              valorItem: previa.valorItemTotal,
              valorAdicional: previa.adicionalTotal,
              valorTotal: previa.valorTotal
            });
          } else {
            setPedidoItemSelLocal(novo);
          }
        }}
      />
    </ModalContainer>
  );
}
